{
  "meta": {
    "manager": {
      "name": "Casey Whitmore",
      "first_name": "Casey"
    },
    "report": {
      "name": "Riley Tanaka",
      "first_name": "Riley",
      "role": "Marketing Analyst",
      "tenure": "~6 months"
    },
    "period": {
      "start": "2025-07-15",
      "end": "2026-01-27"
    },
    "generated": "2026-03-06",
    "data_counts": {
      "meetings": 4,
      "work_summaries": 5,
      "goals": 2,
      "checkins": 1,
      "recognitions": 0
    }
  },
  "sources": [
    {
      "type": "meeting",
      "title": "Casey / Riley 1:1 — Campaign status and deadlines",
      "source_ref": "meeting_5101"
    },
    {
      "type": "meeting",
      "title": "Casey / Riley 1:1 — Landing page results and Q4 planning",
      "source_ref": "meeting_5102"
    },
    {
      "type": "meeting",
      "title": "Casey / Riley 1:1 — Holiday campaign quick sync",
      "source_ref": "meeting_5103"
    },
    {
      "type": "meeting",
      "title": "Casey / Riley 1:1 — Year-end report and role discussion",
      "source_ref": "meeting_5104"
    },
    {
      "type": "goal",
      "title": "Improve email campaign open rate to 22%",
      "source_ref": "goal_3101"
    },
    {
      "type": "goal",
      "title": "Launch and optimize Q4 holiday marketing campaign",
      "source_ref": "goal_3102"
    },
    {
      "type": "checkin",
      "title": "Goal check-in — Email open rate progress to 15%",
      "source_ref": "checkin_6101"
    },
    {
      "type": "work_summary",
      "title": "Week of Jul 28 — Email campaign setup and segmentation",
      "source_ref": "work_summary_7101"
    },
    {
      "type": "work_summary",
      "title": "Week of Aug 11 — Landing page copy and review wait",
      "source_ref": "work_summary_7102"
    },
    {
      "type": "work_summary",
      "title": "Week of Oct 6 — Holiday campaign planning and research",
      "source_ref": "work_summary_7103"
    },
    {
      "type": "work_summary",
      "title": "Week of Nov 17 — Holiday emails shipped, year-end report started",
      "source_ref": "work_summary_7104"
    },
    {
      "type": "work_summary",
      "title": "Week of Jan 20 — Overdue year-end report, stuck without direction",
      "source_ref": "work_summary_7105"
    }
  ],
  "dashboard": [
    {
      "dimension": "Meeting Frequency",
      "icon": "📅",
      "status": "critical",
      "status_label": "Severely Irregular",
      "detail": "4 meetings in 6 months, gaps up to 12 weeks"
    },
    {
      "dimension": "Blockers & Support",
      "icon": "🚧",
      "status": "critical",
      "status_label": "Unresolved",
      "detail": "3 blockers raised, 0 resolved"
    },
    {
      "dimension": "Feedback & Recognition",
      "icon": "🏅",
      "status": "critical",
      "status_label": "Absent",
      "detail": "Zero recognitions, zero specific feedback"
    },
    {
      "dimension": "Psychological Safety",
      "icon": "🛡️",
      "status": "critical",
      "status_label": "Eroding",
      "detail": "Concerns raised and ignored repeatedly"
    },
    {
      "dimension": "Expectations Tracker",
      "icon": "🎯",
      "status": "critical",
      "status_label": "Drifting",
      "detail": "Both goals at risk, 1 overdue deliverable"
    },
    {
      "dimension": "Autonomy & Delegation",
      "icon": "🧭",
      "status": "alert",
      "status_label": "Abandonment",
      "detail": "Autonomy without guidance or support"
    },
    {
      "dimension": "Career Growth",
      "icon": "🌱",
      "status": "alert",
      "status_label": "Missing",
      "detail": "1 interest mentioned, 0 follow-ups"
    },
    {
      "dimension": "Meeting Structure",
      "icon": "📋",
      "status": "alert",
      "status_label": "Underperforming",
      "detail": "Status updates only, no action tracking"
    },
    {
      "dimension": "Workload Balance",
      "icon": "⚖️",
      "status": "alert",
      "status_label": "Overloaded",
      "detail": "3 major projects, no prioritization support"
    },
    {
      "dimension": "Personal Connection",
      "icon": "💬",
      "status": "alert",
      "status_label": "Minimal",
      "detail": "Zero personal touchpoints recorded"
    },
    {
      "dimension": "Talk Ratio",
      "icon": "🎙️",
      "status": "warn",
      "status_label": "Manager-Heavy",
      "detail": "Manager directs most conversations"
    },
    {
      "dimension": "Decision Making",
      "icon": "⚡",
      "status": "alert",
      "status_label": "Stalled",
      "detail": "Key decisions deferred or vague"
    },
    {
      "dimension": "Energy Alignment",
      "icon": "🔋",
      "status": "warn",
      "status_label": "Unknown",
      "detail": "Interests surfaced but never explored"
    },
    {
      "dimension": "Team Dynamics",
      "icon": "🤝",
      "status": "warn",
      "status_label": "Isolated",
      "detail": "No peer collaboration visible"
    }
  ],
  "dimensions": [
    {
      "name": "Meeting Frequency",
      "icon": "📅",
      "status": "critical",
      "insights": [
        {
          "title": "Only 4 meetings in over 6 months",
          "priority": "high",
          "body": "Riley has had only 4 one-on-ones with you since starting in July 2025. For a new hire in their first 6 months, this is critically insufficient. Weekly meetings are the standard for someone ramping up; even biweekly would require 13+ meetings in this period. Riley has had roughly one meeting every 6 weeks.",
          "evidence": [
            {
              "text": "Meeting dates: Aug 5, Sep 16 (6-week gap), Nov 4 (7-week gap), Jan 27 (12-week gap)",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Immediately establish a weekly 30-minute 1:1 with Riley and protect it. For a new hire at 6 months tenure, this is non-negotiable. Put it on the calendar as recurring and treat it as your highest-priority meeting.",
            "variant": "default"
          }
        },
        {
          "title": "12-week gap between November and January is a crisis",
          "priority": "high",
          "body": "The longest gap — from Nov 4 to Jan 27 — spans nearly three months. During this time, Riley was working on the year-end report without clear direction, sending unanswered Slack messages, and missing a deadline. This gap directly caused the overdue deliverable and eroded Riley's trust that raising concerns leads to help.",
          "evidence": [
            {
              "text": "Nov 4 meeting cut to 15 min due to Casey's scheduling conflict; next meeting not until Jan 27",
              "source_ref": "meeting_5103"
            },
            {
              "text": "Riley noted in Jan 27 meeting: 'I asked for a template or example twice in Slack and never got a response.'",
              "source_ref": "meeting_5104"
            }
          ],
          "action": {
            "label": "Open Next Meeting With",
            "text": "Riley, I owe you an apology. We went nearly three months without a proper 1:1, and that's entirely on me. You deserved more support, especially on the year-end report. I'm committing to weekly meetings from now on — and I mean it. Can we put a recurring slot on the calendar right now?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Blockers & Support",
      "icon": "🚧",
      "status": "critical",
      "insights": [
        {
          "title": "Three distinct blockers raised, none resolved",
          "priority": "high",
          "body": "Riley has raised at least three clear blockers across meetings and work summaries: needing A/B testing tool access, needing feedback/review on deliverables before they ship, and needing a template or format guidance for the year-end report. All three went unresolved. This pattern teaches Riley that asking for help is pointless — the most damaging lesson a new hire can learn.",
          "evidence": [
            {
              "text": "Work summary Jul 28: 'Drafted initial subject lines for A/B testing (not yet run — need access to A/B testing feature)'",
              "source_ref": "work_summary_7101"
            },
            {
              "text": "Goal check-in Sep 16: 'Need guidance on A/B testing tools'",
              "source_ref": "checkin_6101"
            },
            {
              "text": "Riley note Nov 17: 'Unclear on the expected format — messaged Casey on Slack but haven't heard back yet'",
              "source_ref": "work_summary_7104"
            },
            {
              "text": "Riley note Jan 27: 'I asked for a template or example twice in Slack and never got a response'",
              "source_ref": "meeting_5104"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Before the next 1:1, resolve the A/B testing access blocker (grant the tool access or provide a workaround), send Riley a year-end report template or example, and commit to a 24-hour Slack response SLA for Riley's questions. Show through action that asking for help works.",
            "variant": "default"
          }
        },
        {
          "title": "Feedback review bottleneck is slowing Riley down",
          "priority": "high",
          "body": "Riley submitted the landing page copy on Monday and didn't receive feedback until Friday, forcing a rush publish. Riley's note explicitly says the hero copy wasn't strong enough because there was no review cycle. Your review turnaround is a blocker for Riley's output quality and their learning.",
          "evidence": [
            {
              "text": "Work summary Aug 11: 'Submitted to Casey for review on Monday. Didn't receive feedback until Friday afternoon. Made requested changes and published same day.'",
              "source_ref": "work_summary_7102"
            },
            {
              "text": "Riley note Sep 16: 'I think the hero copy wasn't strong enough but I didn't get feedback before it went live. Would have been helpful to have a review cycle.'",
              "source_ref": "meeting_5102"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I want to set up a better review process so you're never waiting on me for days. Let's agree: when you submit something for review, I'll turn it around within 48 hours. If I can't, I'll tell you so you're not stuck waiting. Does that work?",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Feedback & Recognition",
      "icon": "🏅",
      "status": "critical",
      "insights": [
        {
          "title": "Zero recognition in six months",
          "priority": "high",
          "body": "There is not a single instance of recognition — formal or informal — in the entire dataset. Riley has shipped a product launch landing page, executed a holiday campaign that improved open rates from 18% to 19.5%, researched 8 competitor campaigns, and built a 12-touchpoint content calendar. None of this was acknowledged. For a new hire, this silence is devastating to motivation.",
          "evidence": [
            {
              "text": "No recognitions exist in the dataset",
              "source_ref": null
            },
            {
              "text": "Holiday campaign open rate improved to 19.5% from Q3's 18% — no feedback from Casey",
              "source_ref": "work_summary_7104"
            },
            {
              "text": "Casey's only feedback on holiday campaign draft: 'looks fine'",
              "source_ref": "meeting_5103"
            }
          ],
          "action": {
            "label": "Open Next Meeting With",
            "text": "Riley, I want to start by acknowledging something I should have said months ago. You took the holiday campaign from zero to shipped — researched competitors, built the content calendar, executed across channels — and the open rate improved over Q3. That's real progress and I didn't call it out at the time. I'm sorry about that. Your work matters and I need to do a better job of telling you that.",
            "variant": "green"
          }
        },
        {
          "title": "Feedback is exclusively corrective and vague",
          "priority": "high",
          "body": "The only feedback patterns in the data are negative: 'figure out what's going wrong' (Aug 5), noting the landing page conversion miss without analysis (Sep 16), and frustration about the overdue report (Jan 27). There's no constructive feedback framed around growth, no positive feedback, and no specificity. Riley explicitly said: 'I don't know if my work is good or bad — just get told to ship it.' This is a feedback desert.",
          "evidence": [
            {
              "text": "Aug 5: Casey asked Riley to 'figure out what's going wrong' with open rates — no guidance offered",
              "source_ref": "meeting_5101"
            },
            {
              "text": "Riley note Nov 4: 'I feel like I'm flying blind on these projects. I don't know if my work is good or bad — just get told to ship it.'",
              "source_ref": "meeting_5103"
            },
            {
              "text": "Nov 4: Casey said holiday campaign 'looks fine' and to ship it — no detailed feedback",
              "source_ref": "meeting_5103"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Commit to giving Riley one piece of specific positive feedback and one piece of constructive (growth-oriented) feedback every week. Use SBI format for constructive feedback: Situation, Behavior, Impact. For example: 'In the holiday campaign, you structured the content calendar with 12 touchpoints across three channels — that level of planning is exactly what I want to see more of.'",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Psychological Safety",
      "icon": "🛡️",
      "status": "critical",
      "insights": [
        {
          "title": "Riley's concerns are consistently raised and consistently ignored",
          "priority": "high",
          "body": "Riley has shown significant courage for a new hire: they raised the need for A/B testing guidance, flagged the missing review cycle, expressed feeling 'like flying blind,' asked for a year-end report template twice on Slack, and directly told you they feel their overdue work 'feels like it's my fault' when they weren't given what they needed. Every one of these signals was either ignored or met with a non-response. This is the fastest way to destroy psychological safety — Riley is learning that honesty has no upside.",
          "evidence": [
            {
              "text": "Riley note Sep 16: 'I think the hero copy wasn't strong enough but I didn't get feedback before it went live'",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Riley note Nov 4: 'I feel like I'm flying blind on these projects'",
              "source_ref": "meeting_5103"
            },
            {
              "text": "Riley note Jan 27: 'I asked for a template or example twice in Slack and never got a response. Now I'm behind and it feels like it's my fault.'",
              "source_ref": "meeting_5104"
            },
            {
              "text": "Sep 16: Riley mentioned wanting to learn A/B testing but 'the conversation moved on'",
              "source_ref": "meeting_5102"
            }
          ],
          "action": {
            "label": "Open Next Meeting With",
            "text": "Riley, I've been reflecting on our working relationship and I need to own something. You've raised important concerns multiple times — about needing A/B testing guidance, needing review cycles, needing clarity on the year-end report — and I dropped the ball on all of them. That's not okay. I want you to know that when you raise things, I hear them and I will act on them. Here's what I've already done since our last meeting: [list concrete actions taken]. And I want to ask — is there anything else you've been hesitant to bring up?",
            "variant": "default"
          }
        },
        {
          "title": "Blame is shifting to Riley for systemic failures",
          "priority": "high",
          "body": "The year-end report situation is the clearest example: Riley asked for a template twice, got no response, missed the deadline, and then felt the blame was on them. Similarly, the email open rate miss was framed as Riley's problem to solve ('figure out what's going wrong') despite Riley lacking access to A/B testing tools. When a manager doesn't provide necessary resources and then holds the report accountable for the outcome, it creates learned helplessness.",
          "evidence": [
            {
              "text": "Jan 27: 'Casey seemed frustrated but acknowledged they hadn't provided a template or examples'",
              "source_ref": "meeting_5104"
            },
            {
              "text": "Aug 5: Casey asked Riley to 'figure out what's going wrong' without offering tools or guidance",
              "source_ref": "meeting_5101"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I want to be clear about the year-end report: the missed deadline was on me, not you. You asked for what you needed and I didn't respond. Going forward, if you need something from me and don't hear back within a day, I want you to escalate — message me again, ping me in a meeting, whatever it takes. I'd rather be nudged than leave you stuck.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Expectations Tracker",
      "icon": "🎯",
      "status": "critical",
      "insights": [
        {
          "title": "Both goals are at risk with minimal tracking",
          "priority": "high",
          "body": "The email open rate goal (target 22%) sits at 15% progress with the deadline already passed (Dec 31, 2025). The holiday campaign goal is at 30% progress with its deadline also passed (Dec 20, 2025). There's been only one goal check-in recorded in the entire period. Goals were set and then essentially abandoned — no regular review, no course correction, no support when they fell behind.",
          "evidence": [
            {
              "text": "Email open rate goal at 15% progress, due Dec 31 2025 — open rate reached 19.5% but target was 22%",
              "source_ref": "goal_3101"
            },
            {
              "text": "Holiday campaign goal at 30% progress, due Dec 20 2025",
              "source_ref": "goal_3102"
            },
            {
              "text": "Only one goal check-in recorded (Sep 16) across the entire period",
              "source_ref": "checkin_6101"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I want to revisit your goals because I haven't done a good job of staying connected to them. Let's look at the email open rate and holiday campaign goals together — what worked, what didn't, and what you learned. Then let's set fresh goals for Q1 that feel relevant and that we'll actually review every week.",
            "variant": "default"
          }
        },
        {
          "title": "Year-end report deadline missed due to unclear expectations",
          "priority": "high",
          "body": "The year-end report was due January 15 and is still incomplete as of January 27. Riley was unclear on the audience and format, requested guidance twice via Slack with no response, and only got clarity when the overdue deliverable was discussed in the meeting. This is a textbook expectations failure: a deliverable was assigned without sufficient context and then not tracked until it was late.",
          "evidence": [
            {
              "text": "Jan 27: 'Riley said they were unclear on the expected format and audience. Casey acknowledged they hadn't provided a template or examples.'",
              "source_ref": "meeting_5104"
            },
            {
              "text": "Work summary Jan 20: 'Struggling with the narrative framing — don't know if this is for the exec team or just our department'",
              "source_ref": "work_summary_7105"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Send Riley the year-end report template, specify the audience (exec team vs. department), and provide an example from a previous year if one exists. For all future deliverables, use a brief kickoff: what's the deliverable, who's it for, what does good look like, when is it due, and what resources are available.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Autonomy & Delegation",
      "icon": "🧭",
      "status": "alert",
      "insights": [
        {
          "title": "Autonomy without support is abandonment, not empowerment",
          "priority": "high",
          "body": "Riley is at roughly 6 months tenure — squarely in the Coaching (S2) phase of situational leadership. They need you to explain the why, provide context, invite their input, and guide the process. Instead, the pattern is S1-style directing (assigning tasks without discussion) combined with S4-style delegation (leaving them alone for weeks). This is the worst combination: being told what to do but not supported in how to do it. Riley's note — 'I feel like I'm flying blind' — captures this perfectly.",
          "evidence": [
            {
              "text": "Sep 16: Casey outlined Q4 priorities and 'assigned all three to Riley without discussing bandwidth or prioritization'",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Nov 4 Riley note: 'I feel like I'm flying blind on these projects. I don't know if my work is good or bad — just get told to ship it.'",
              "source_ref": "meeting_5103"
            },
            {
              "text": "Aug 5: Casey asked Riley to 'figure out what's going wrong' without offering tools, guidance, or analysis approach",
              "source_ref": "meeting_5101"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I think I've been giving you tasks without enough context or support, and that's not fair. At this stage I should be coaching you through projects — explaining the why, talking through approaches together, and giving you real feedback. Going forward, for any new project, let's start with a 15-minute kickoff where we align on the goal, audience, approach, and what good looks like. Would that help?",
            "variant": "default"
          }
        },
        {
          "title": "Riley shows initiative but it goes unrecognized and unsupported",
          "priority": "medium",
          "body": "Despite the lack of guidance, Riley has demonstrated genuine initiative: researching 8 competitor campaigns, drafting a 12-touchpoint content calendar, independently trying subject line variations, and proactively starting the year-end report research. This self-direction is impressive for a 6-month employee and suggests high potential. But without feedback or support, this initiative will eventually burn out.",
          "evidence": [
            {
              "text": "Work summary Oct 6: 'Researched 8 competitor holiday campaigns. Drafted initial content calendar with 12 touchpoints across email, social, and blog.'",
              "source_ref": "work_summary_7103"
            },
            {
              "text": "Work summary Jul 28: 'Created 3 audience segments based on engagement history. Drafted initial subject lines for A/B testing'",
              "source_ref": "work_summary_7101"
            }
          ],
          "action": {
            "label": "Keep Doing",
            "text": "Riley's self-direction is a strength to nurture. When Riley proposes an approach (like the competitor research or the segmentation strategy), acknowledge it explicitly: 'That was a great instinct to research competitors before building the campaign. That's exactly the kind of thinking I want to see more of.' Then build on it by coaching: 'What did you learn from that research that we should apply?'",
            "variant": "green"
          }
        }
      ]
    },
    {
      "name": "Career Growth",
      "icon": "🌱",
      "status": "alert",
      "insights": [
        {
          "title": "A/B testing interest was raised and immediately dropped",
          "priority": "high",
          "body": "Riley explicitly mentioned wanting to learn A/B testing in the September 16 meeting, and flagged needing A/B testing tool access in their very first work summary and goal check-in. This is a clear growth signal — Riley identified a specific skill gap relevant to their goals. The conversation moved on and it was never revisited. When a report's growth interest is ignored, they stop sharing them.",
          "evidence": [
            {
              "text": "Sep 16: 'Riley mentioned wanting to learn A/B testing but the conversation moved on'",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Goal check-in Sep 16: 'Need guidance on A/B testing tools'",
              "source_ref": "checkin_6101"
            },
            {
              "text": "Work summary Jul 28: 'Drafted initial subject lines for A/B testing (not yet run — need access to A/B testing feature)'",
              "source_ref": "work_summary_7101"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, you mentioned months ago that you wanted to learn A/B testing, and I never followed up on that. I'm sorry. Let's make that a real goal for Q1. What would help most — access to the testing tools in Mailchimp, an online course, or pairing with someone who's done it before? Let's figure out a plan together.",
            "variant": "default"
          }
        },
        {
          "title": "Zero career conversations in six months",
          "priority": "high",
          "body": "There has been no discussion about Riley's career aspirations, long-term goals, or professional development in any of the four meetings. For a new hire at 6 months, this is when career conversations should be starting: Where do they want to go? What skills do they want to build? What kind of marketer do they want to become? The total absence of these conversations signals that Riley's growth isn't on the radar.",
          "evidence": [
            {
              "text": "No meeting summaries or highlights contain career-related discussion beyond the brief A/B testing mention",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I realize we haven't talked about your career goals at all, and that's an oversight. I'd like to understand where you want to go. What kind of marketer do you want to be in two years? Is there a specialty — analytics, content strategy, growth, brand — that excites you most? Let's start building a development plan around that.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Meeting Structure",
      "icon": "📋",
      "status": "alert",
      "insights": [
        {
          "title": "Meetings are status updates without depth or action items",
          "priority": "high",
          "body": "All four meetings follow the same pattern: Riley shares what they've been working on, Casey responds briefly, and the meeting ends without clear action items, follow-ups, or deeper discussion. There are no tracked action items in any meeting. Career, feedback, blockers, and personal topics are entirely absent from the meeting structure. One meeting was cut to 15 minutes. The meetings aren't serving Riley's needs.",
          "evidence": [
            {
              "text": "Aug 5: Brief check-in covering status and deadlines with no highlights or action items",
              "source_ref": "meeting_5101"
            },
            {
              "text": "Nov 4: Meeting cut to 15 min, Casey said campaign 'looks fine' and to ship it, no detailed discussion",
              "source_ref": "meeting_5103"
            },
            {
              "text": "No meeting in the dataset contains highlights of type action-item, feedback, career, or personal",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Restructure your 1:1s using this format: (1) Check-in — 'How are you doing, genuinely?' 5 min. (2) Riley's agenda — 'What's on your mind?' 10-15 min. (3) Growth topic — rotate through: career check-in, recognition, constructive feedback, blockers. 5-10 min. (4) Your items — context, alignment. 5 min. (5) Action items — 'What are we each committing to before next time?' 2 min. End every meeting with explicit next steps written down.",
            "variant": "default"
          }
        },
        {
          "title": "Riley's individual notes reveal what the meetings miss",
          "priority": "medium",
          "body": "Riley's individual notes are remarkably candid and insightful — they identify root causes (weak hero copy from no review), express emotional state (flying blind, feels like my fault), and show problem-solving (narrative framing challenges). These notes suggest Riley has important things to say that aren't making it into the meeting conversation. The meetings aren't creating space for Riley to share what's really on their mind.",
          "evidence": [
            {
              "text": "Riley note Sep 16: 'I think the hero copy wasn't strong enough but I didn't get feedback before it went live'",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Riley note Nov 4: 'I feel like I'm flying blind on these projects'",
              "source_ref": "meeting_5103"
            },
            {
              "text": "Riley note Jan 27: 'I asked for a template or example twice in Slack and never got a response. Now I'm behind and it feels like it's my fault.'",
              "source_ref": "meeting_5104"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I want to make sure our 1:1s are actually useful for you, not just a check-the-box meeting. Starting next week, I'd like you to set the agenda — bring whatever's on your mind, whether it's a blocker, something you're excited about, feedback for me, or anything else. I'll add my items around yours. This is your meeting.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Workload Balance",
      "icon": "⚖️",
      "status": "alert",
      "insights": [
        {
          "title": "Three major projects assigned without prioritization or bandwidth discussion",
          "priority": "high",
          "body": "In the September 16 meeting, Casey assigned the holiday campaign, year-end report, and blog content calendar to Riley in a single conversation with no discussion of bandwidth, prioritization, or tradeoffs. For a Marketing Analyst at 6 months tenure managing their first full quarter, this is a significant load — especially without regular check-ins to adjust course. The year-end report deadline was missed as a direct consequence.",
          "evidence": [
            {
              "text": "Sep 16: 'Casey outlined Q4 priorities: holiday campaign, year-end report, and blog content calendar. Assigned all three to Riley without discussing bandwidth or prioritization.'",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Year-end report due Jan 15, still incomplete as of Jan 27",
              "source_ref": "meeting_5104"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I think I overloaded you in Q4 without talking about how to prioritize. That's on me. For Q1, let's do this differently: let's list everything on your plate, stack-rank it together, and agree on what's #1, #2, and what can wait. If new things come in, we'll decide together what moves down. Sound good?",
            "variant": "default"
          }
        },
        {
          "title": "Wait time and dependencies are eating productive weeks",
          "priority": "medium",
          "body": "Riley has lost significant productive time waiting on Casey: an entire week waiting for landing page feedback, weeks waiting for Slack responses about the year-end report format, and ongoing lack of A/B testing tool access. These aren't just blockers — they're wasted capacity. A new hire sitting idle because their manager isn't responsive is both a productivity loss and a morale hit.",
          "evidence": [
            {
              "text": "Work summary Aug 11: 'Submitted to Casey for review on Monday. Didn't receive feedback until Friday afternoon.'",
              "source_ref": "work_summary_7102"
            },
            {
              "text": "Work summary Nov 17: 'Messaged Casey on Slack but haven't heard back yet' regarding year-end report format",
              "source_ref": "work_summary_7104"
            },
            {
              "text": "Work summary Jan 20: 'Asked Casey again for clarification' — still waiting",
              "source_ref": "work_summary_7105"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Set a personal SLA: respond to Riley's Slack messages within 24 hours, even if the response is 'I don't have the answer yet but I'll get back to you by [date].' When Riley submits work for review, turn it around within 48 hours. Block 30 minutes on Fridays specifically for reviewing Riley's work.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Personal Connection",
      "icon": "💬",
      "status": "alert",
      "insights": [
        {
          "title": "Zero personal touchpoints in six months of meetings",
          "priority": "high",
          "body": "There is not a single personal topic, mood check-in, or rapport-building moment recorded across all four meetings. Every conversation goes straight to task status. For a new hire, the first 6 months are when the personal connection is most important — it builds the trust foundation that makes everything else work. Riley is currently a task executor, not a person their manager knows.",
          "evidence": [
            {
              "text": "No meeting contains personal topics, mood data, or rapport-building content",
              "source_ref": null
            },
            {
              "text": "All four meetings jump directly to campaign status or project updates",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Open Next Meeting With",
            "text": "Before we get into any work stuff — how are you doing, Riley? Not work-you, but you-you. We've been pretty heads-down on projects and I realize I haven't asked that enough. How's everything going?",
            "variant": "default"
          }
        },
        {
          "title": "Riley's emotional signals are present but unacknowledged",
          "priority": "medium",
          "body": "Riley's individual notes reveal real emotional states: frustration about lack of feedback, feeling like failures are their fault, feeling like they're flying blind. These are strong signals that Riley is struggling emotionally, not just operationally. But none of this emotional content appears in the meeting summaries, suggesting it's either not being shared verbally or not being heard when it is.",
          "evidence": [
            {
              "text": "Riley note Nov 4: 'I feel like I'm flying blind on these projects. I don't know if my work is good or bad.'",
              "source_ref": "meeting_5103"
            },
            {
              "text": "Riley note Jan 27: 'Now I'm behind and it feels like it's my fault.'",
              "source_ref": "meeting_5104"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I want to check in on something. I know the last few months have been bumpy — the year-end report timing, the gaps in our meetings, me not being responsive enough. How has all of that felt for you? I want to hear honestly, because I can't fix what I don't know about.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Decision Making",
      "icon": "⚡",
      "status": "alert",
      "insights": [
        {
          "title": "Key decisions are deferred with vague non-answers",
          "priority": "high",
          "body": "Two significant decisions have been punted without resolution. When Riley asked about the year-end report timeline, Casey said 'we'll figure it out later' — and then didn't. When Riley asked what the team restructuring means for their role, Casey said 'we'll see.' Both responses leave Riley in limbo. Vague deferrals on things that directly affect someone's work and role are corrosive to engagement.",
          "evidence": [
            {
              "text": "Nov 4: Riley asked about year-end report timeline, Casey said 'we'll figure it out later'",
              "source_ref": "meeting_5103"
            },
            {
              "text": "Jan 27: Riley asked what restructuring means for their role, Casey said 'we'll see'",
              "source_ref": "meeting_5104"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, you asked about the team restructuring and I gave you a non-answer. That's not fair to you. Here's what I know right now: [share what you know]. Here's what I don't know yet: [be honest]. And here's when I expect to have more clarity: [give a date]. Even if the answer is uncertain, I want to be transparent with you rather than vague.",
            "variant": "default"
          }
        },
        {
          "title": "No evidence of joint decision-making",
          "priority": "medium",
          "body": "Across all meetings, decisions follow a one-way pattern: Casey tells Riley what to do (work on Q4 priorities, ship the campaign, figure out the open rate issue). There's no evidence of Riley being invited to weigh in on approach, priorities, or strategy. For a Marketing Analyst growing into their role, being included in the 'how' and 'why' — not just the 'what' — is essential for development and engagement.",
          "evidence": [
            {
              "text": "Sep 16: Casey outlined Q4 priorities and assigned all three without discussion",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Aug 5: Casey directed Riley to 'figure out what's going wrong' — no collaborative problem-solving",
              "source_ref": "meeting_5101"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I want to start making decisions together rather than just handing you tasks. For Q1 planning, what do you think our top priorities should be? I have my perspective but I want to hear yours first — you're closer to the work than I am.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Talk Ratio",
      "icon": "🎙️",
      "status": "warn",
      "insights": [
        {
          "title": "Manager appears to direct most conversations",
          "priority": "medium",
          "body": "While no explicit talk ratio data is available, the meeting summaries reveal a consistent pattern: Casey outlines priorities, assigns tasks, and gives brief reactions to Riley's updates. Riley shares status but isn't asked open-ended questions, invited to propose approaches, or given space to raise concerns. The meetings read as manager-directed briefings rather than report-driven conversations. Riley's richest thoughts appear only in their private notes — not in the conversation itself.",
          "evidence": [
            {
              "text": "Sep 16: Casey outlined Q4 priorities and assigned three workstreams — Riley's input not solicited",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Aug 5: Casey asked Riley to 'figure out what's going wrong' — directive, not exploratory",
              "source_ref": "meeting_5101"
            },
            {
              "text": "Riley's individual notes contain deeper insights than what appears in meeting summaries, suggesting they're not getting airtime",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Start every 1:1 with 'What's on your mind?' and then be quiet for at least 10 seconds. Replace directives with questions: instead of 'work on X,' try 'What do you think we should focus on?' Instead of 'figure out what's wrong,' try 'What's your hypothesis about why open rates are below target?' Aim for Riley to talk 70% of the time.",
            "variant": "default"
          }
        }
      ]
    },
    {
      "name": "Energy Alignment",
      "icon": "🔋",
      "status": "warn",
      "insights": [
        {
          "title": "Competitor research and content planning show high energy",
          "priority": "low",
          "body": "The work Riley initiated on their own — researching 8 competitor campaigns, building a 12-touchpoint content calendar, experimenting with audience segmentation — suggests these strategic and analytical activities energize them. In contrast, work done under pressure with unclear direction (year-end report) or without tools (A/B testing) appears draining. This is a useful signal for how to structure Riley's work going forward.",
          "evidence": [
            {
              "text": "Work summary Oct 6: Self-initiated research of 8 competitor campaigns and drafted a 12-touchpoint content calendar",
              "source_ref": "work_summary_7103"
            },
            {
              "text": "Work summary Jul 28: Independently created 3 audience segments based on engagement history",
              "source_ref": "work_summary_7101"
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, I noticed you did some really thorough competitive research and content planning on your own initiative. Was that work you enjoyed? What part of your role energizes you most right now — and what feels like a grind? I want to make sure we're leaning into your strengths.",
            "variant": "default"
          }
        },
        {
          "title": "Interest in analytics and testing is an untapped growth vector",
          "priority": "medium",
          "body": "Riley's interest in A/B testing, combined with their initiative on audience segmentation and metrics analysis, suggests a natural pull toward data-driven marketing. If nurtured, this could become Riley's specialty and a major value-add for the team. Currently it's blocked by lack of tool access and guidance.",
          "evidence": [
            {
              "text": "Sep 16: Riley mentioned wanting to learn A/B testing",
              "source_ref": "meeting_5102"
            },
            {
              "text": "Goal check-in: 'Need guidance on A/B testing tools'",
              "source_ref": "checkin_6101"
            },
            {
              "text": "Work summary Jul 28: Independently created audience segments based on engagement history",
              "source_ref": "work_summary_7101"
            }
          ],
          "action": {
            "label": "Manager Action",
            "text": "Unblock A/B testing access this week. Position Riley's interest in analytics as a team asset: 'You're naturally gravitating toward the data side of marketing, which is exactly what our team needs. Let's make that a core part of your role, not just a side interest.'",
            "variant": "green"
          }
        }
      ]
    },
    {
      "name": "Team Dynamics",
      "icon": "🤝",
      "status": "warn",
      "insights": [
        {
          "title": "Riley appears isolated with no visible peer collaboration",
          "priority": "medium",
          "body": "Across all work summaries and meetings, there is no mention of collaboration with anyone other than Casey. No peer reviews, no cross-functional work, no team interactions beyond a single marketing standup mention. For a new hire on a Growth Marketing team, this level of isolation is concerning. Riley may be the only person on their team, or they may simply not be connected to others. Either way, they have no peer support network.",
          "evidence": [
            {
              "text": "Work summary Jul 28: Only external interaction mentioned is 'Attended marketing team standup'",
              "source_ref": "work_summary_7101"
            },
            {
              "text": "No other team members mentioned in any meeting or work summary",
              "source_ref": null
            }
          ],
          "action": {
            "label": "Suggested Discussion Topic",
            "text": "Riley, who are you working with day to day besides me? Do you feel like you have people to bounce ideas off or get feedback from? I want to make sure you're connected to the broader team and not doing everything solo. Is there someone on the team — or in the company — you'd like to work with more?",
            "variant": "default"
          }
        }
      ]
    }
  ],
  "agenda": {
    "next_meeting": [
      {
        "topic": "Acknowledge and apologize for meeting gaps and dropped support",
        "tags": ["psychological safety", "personal connection"],
        "opener": "Riley, I want to start by being honest — I've let you down on several fronts over the last few months, and I want to own that before we talk about anything else. Can I share what I've been reflecting on?"
      },
      {
        "topic": "Resolve the year-end report blocker immediately",
        "tags": ["blockers", "expectations"],
        "opener": "I brought the year-end report template and examples I should have given you months ago. The audience is [specify]. Let's walk through the format together so you have everything you need to finish strong."
      },
      {
        "topic": "Unblock A/B testing tool access",
        "tags": ["blockers", "career growth"],
        "opener": "I've [granted/requested] access to A/B testing in Mailchimp for you. You first asked about this in July and it should have been handled immediately. Let's set up your first test this week."
      },
      {
        "topic": "Specific recognition for Riley's initiative and accomplishments",
        "tags": ["feedback", "recognition"],
        "opener": "Before we go further — I want to acknowledge the work you've done: the competitive research, the 12-touchpoint content calendar, improving open rates from Q3 to Q4. You showed real initiative and I didn't recognize any of it. That changes now."
      },
      {
        "topic": "Prioritize Q1 workload together",
        "tags": ["workload", "decision making", "autonomy"],
        "opener": "Let's look at everything on your plate right now and stack-rank it together. What do you think should be your #1 focus for the next two weeks? I want to hear your perspective first."
      },
      {
        "topic": "Establish a reliable communication contract",
        "tags": ["blockers", "psychological safety"],
        "opener": "I'm committing to a 24-hour Slack response time and 48-hour review turnaround. If I miss that, I want you to nudge me — that's not being pushy, it's holding me accountable. Does that feel reasonable?"
      },
      {
        "topic": "Open career growth conversation",
        "tags": ["career growth", "energy alignment"],
        "opener": "You mentioned interest in A/B testing and you gravitate toward data and analytics. Where do you want to go with your career? What kind of marketer do you want to become?"
      },
      {
        "topic": "Check on team connections and isolation",
        "tags": ["team dynamics", "personal connection"],
        "opener": "Who are you working with day to day besides me? Do you feel like you have people you can go to for feedback or brainstorming?"
      }
    ],
    "phased_plan": [
      {
        "meeting": "Meeting 1 — Reset and Repair",
        "theme": "Rebuild trust through accountability, clear up blockers, and deliver overdue recognition",
        "topics": [
          "Open with genuine apology for meeting gaps, dropped Slack messages, and lack of support — own it fully without excuses",
          "Hand over year-end report template, clarify audience, and walk through format together",
          "Confirm A/B testing tool access is granted and set up first experiment",
          "Deliver specific recognition for competitive research, content calendar, and open rate improvement",
          "Establish communication contract: 24-hour Slack response, 48-hour review turnaround, weekly 1:1 locked on calendar",
          "End with: 'Is there anything else I've dropped that we need to address? I want to get everything on the table.'"
        ]
      },
      {
        "meeting": "Meeting 2 — Structure and Direction",
        "theme": "Set clear expectations, prioritize work together, and begin shifting to a coaching dynamic",
        "topics": [
          "Personal check-in: 'How are you feeling after our last conversation? Has anything changed?'",
          "Jointly prioritize Q1 workload: list everything, stack-rank together, agree on top 2 priorities",
          "Set 2-3 fresh Q1 goals together — include at least one growth goal (A/B testing skill development)",
          "Provide constructive feedback on a specific piece of recent work using SBI format",
          "Discuss team restructuring honestly: share what you know, what you don't, and when you expect clarity",
          "Introduce new meeting structure: Riley brings agenda first, end with written action items"
        ]
      },
      {
        "meeting": "Meeting 3 — Growth and Future",
        "theme": "Career development conversation and sustainable rhythm confirmation",
        "topics": [
          "Personal check-in: ask about life outside work, build genuine rapport",
          "Career conversation: 'Where do you want to be in a year? What kind of marketer do you want to become?'",
          "Review A/B testing progress: has Riley run their first test? What did they learn?",
          "Discuss peer connections: identify one person Riley could collaborate with more closely",
          "Review action items from Meetings 1 and 2: did you both follow through?",
          "Meta-conversation: 'How are our 1:1s feeling now compared to before? What would make them more useful for you?'"
        ]
      }
    ]
  }
}
